import { ref } from 'vue';
import { SsoConfiguration } from '@/entities/sso-configuration';

export const useSsoConfigurationRecord = () => ref<SsoConfiguration>({
  organizationId: 0,
  emailDomains: [],
  identityProviderType: 'oauth2',
  jitProvisioning: false,
  scimEnabled: false,
  scimRoleMappingEnabled: false,
  scimAccessKey: null,
  scimSchemaNamespace: null,
  scimGroupAttribute: null,
  defaultRole: null,
  configuration: {
    authorizationUri: '',
    tokenUri: '',
    userInfoUri: '',
    clientId: '',
    clientSecret: '',
    scope: '',
  },
});
